export default __webpack_public_path__ + "static/hatsun-89c68ec9e4e1f2ea3ab02849c65597ba.png";